import React, {useState, useEffect} from 'react'
// Styles
import './edapp.style.css'
// Actions
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
// Moment
import moment from 'moment/moment';
// MUI
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { TextField } from '@mui/material';
// JSON
import Location from '../../utils/JSON/location.json'
// Components
import Copyright from '../../components/Copyright';
import RedStart_Required from '../../components/RedStar_Required/index';
// Alert
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom'
// Google Map API
import {GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api'
import { DecryptedOBJ, DecryptedText, EncryptedText } from '../../utils/Encryption';


function Edit_Appointment_Delivery(props) {
    const {hisid, cameFrom, campaignID} = useParams();

    // useLoadScript (Google Map API)
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyAE8CTezQatRj77NfsV0W90wDPxuGrx6AY"
    })

    const [receiveServiceAt, setReceiveServiceAt] = useState('home');
    const [dorc, setDorc] = useState(new Date().setDate(new Date().getDate()+1)); // date of receive service (appointment date)
    const [loading, setLoading] = useState(true);
    const [timeList, setTimeList] = useState(['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00']);
    const [hospitalList, setHospitalList] = useState(null);
    const [canSelectHome, setCanSelectHome] = useState(true);
    const [checkboxSelected, setCheckboxSelected] = useState(null);
    const [isShowHome, setIsShowHome] = useState(false);
    const [datePickerStatus, setDatePickerStatus] = useState(true);
    const [appPeriod, setAppPeriod] = useState({
        startDate: new Date().setDate(new Date().getDate()+1),
        endDate: new Date()
    });
    const [appointData, setAppointData] = useState({
        full_name: '', 
        dorc: moment(new Date().setDate(new Date().getDate()+1)).format('DD/MM/YYYY'), // date of receive service
        email: '',
        contact_number: '',
        time: '',
        note: '',
        
        hospital_name: 'default',
        hospital_code: 'default',

        address: '',
        latitude: '',
        longtitude: '',
        houseNumber: '',
        village: '',
        soi: '',
        street: '',
        province: '',
        amphoe: '',
        district: '',
        zipcode: ''
    });
    // Get Location
    const [getLocationStatus, setGetLocationStatus] = useState(null);
    const [getLocationSuccess, setGetLocationSuccess] = useState(false);
    const [map, setMap] = React.useState(null)
    const [geoNotSupp, setGeoNotSupp] = useState(false);
    const [lat, setLat] = useState(13.7649136);
    const [long, setLong] = useState(100.5360959);
    // Location
    const [province, setProvince] = useState([]);
    const [amphoe, setAmphoe] = useState([]);
    const [district, setDistrict] = useState([]);
    const [zipcode, setZipcode] = useState([]);

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds({lat: lat, lng: long});
        map.fitBounds(bounds);
        setMap(map)
    }, [appointData.latitude])
        const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    useEffect(() => {
        dataInit()
    }, [])

    useEffect(() => {
        clickMapInit();
    }, [document.getElementById('map-wrapp')])

    const clickMapInit = () => {
        let map = document.getElementById('map-wrapp');
        if(!!map) {
            // clear
            setGetLocationSuccess(false);
            setGetLocationStatus(null);
            // get & set
            setTimeout(() => {
                getLocation();
            }, 1000)
        } 
    }

    const dataInit = async() => {
        let getAppointData = await appointDataInit();
        // let campaignData = await campaignInit();        
        await appointmentInit();
        await hospitalListInit(getAppointData);
        await provinceInit();
        console.log('finally(appoint data): ', appointData);
        handlerLoading('inactive');
    }

    const provinceInit = () => {
        return new Promise(async resolve => {
            // validate
            let pv1 = Location.map((item) => {
                return item.province;
            })
            let pv2 = [...new Set(pv1)]
            // console.log('PV2: ', pv2);
            // set
            setProvince(pv2)
            resolve();
        })
    }

    const onSelectedPV = (value, firstTimeSet) => {

        if(value !== 'default')
        {
            appointData["province"] = value;
        }else
        {
            appointData["province"] = "";
        }

        // then (generate amphoe dropdown)
        let amph1 = Location.filter(item => item.province === value);
        let amph2 = amph1.map(item => item.amphoe);
        let amph3 = [...new Set(amph2)];
        setAmphoe(amph3);

        if(firstTimeSet === false)
        {
            // clear (amphoe, district, zipcode)
            document.querySelector("#appm3-ddad-amph").value = "default";
            document.querySelector("#appm3-ddad-dist").value = "default";
            document.querySelector("#appm3-ddad-zc").value = "default";
            appointData["amphoe"] = "";
            appointData["district"] = "";
            appointData["zipcode"] = "";
        }
    }    
    const onSelectedAmph = (value, firstTimeSet) => {

        if(value !== 'default')
        {
            appointData["amphoe"] = value;
        }else
        {
            appointData["amphoe"] = "";
        }

        // then (generate district dropdown)
        let dist1 = Location.filter(item => item.amphoe === value);
        let dist2 = dist1.map(item => item.district);
        let dist3 = [...new Set(dist2)];
        setDistrict(dist3);

        if(firstTimeSet === false)
        {
            // clear (amphoe, district, zipcode)
            document.querySelector("#appm3-ddad-dist").value = "default";
            document.querySelector("#appm3-ddad-zc").value = "default";
            appointData["district"] = "";
            appointData["zipcode"] = "";
        }
    }
    const onSelectedDist = (value, firstTimeSet) => {
        
        if(value !== 'default')
        {
            appointData["district"] = value;
        }else
        {
            appointData["district"] = "";
        }

        // then (generate zipcode dropdown)
        // let zc1 = Location.filter(item => item.district === value && item.amphoe === document.querySelector("#appm3-ddad-amph").value)
        // let zc1 = Location.filter(item => item.district === value)
        let zc1 = Location.filter(item => item.district === value && item.amphoe === appointData["amphoe"])
        let zc2 = zc1.map(item => item.zipcode);
        let zc3 = [...new Set(zc2)];
        // console.log('Zipcode: ', zc3);
        setZipcode(zc3);
        setAppointData({
            ...appointData,
            zipcode: zc3[0]
        })
        appointData["zipcode"] = zc3[0];

        if(firstTimeSet === false)
        {
            // clear (amphoe, district, zipcode)
            document.querySelector("#appm3-ddad-zc").value = "default";
            appointData["zipcode"] = "";
        }
    }
    const onSelectedZipCode = (value) => {
        if(value !== 'default')
        {
            appointData["zipcode"] = value;
        }else
        {
            appointData["zipcode"] = "";
        }
    } 

    const hospitalListInit = (getAppointData) => {
        return new Promise(async resolve => {
            NhealthAction.GetHospitalList(campaignID)
            .then(res => {
                // console.log('Get Hospital List: ', res);
                let hospital_delivery = res.filter(item => item.isDelivery === true);
                setHospitalList(hospital_delivery);

                setAppointData({
                    ...appointData,
                    hospital_code: hospital_delivery[0].hospital_code,
                    hospital_name: hospital_delivery[0].hospital_name,
                    ...getAppointData
                })

                resolve();
            })
        }) 
    }

    const handlerLoading = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const appointmentInit = () => {
        return new Promise(async resolve => {
            let appEndDateRar = DecryptedText(localStorage.getItem('appEndDate'));
            let appEndDate = new Date(Number(appEndDateRar));

            // set end date
            setAppPeriod({
                ...appPeriod,
                endDate: appEndDate
            })

            // check & set disable time picker status
            const toDay = new Date();
            const duration = moment.duration(moment(appEndDate).diff(toDay));
            const compareSeconds = duration.asSeconds();

            if(compareSeconds <= 0)
            {
                setDatePickerStatus(true); // หมดวันทำนัดแล้ว
            }else
            {
                setDatePickerStatus(false);
            }

            resolve();
        })
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetCampaign(ref).then(data => {
                // console.log('Get Campaign: ', data);

                let appEndDateRar = String(data.campaign.appendDate).slice(6, 19);
                let appEndDate = new Date(Number(appEndDateRar));

                setAppPeriod({
                    ...appPeriod,
                    endDate: appEndDate
                })
                resolve();
            })
        })
    }

    const handleCheckboxTime = (e, index) => {
        let checked = e.target.checked;
        let value = e.target.name;

        // console.log(`${value} - ${Number(String(value).slice(0,2))+1}:00`); 

        if(checked)
        {
            setCheckboxSelected(index);
            setAppointData({
                ...appointData,
                time: `${value} - ${Number(String(value).slice(0,2))+1}:00`
            })  

        }else
        {
            setCheckboxSelected(null);
            setAppointData({
                ...appointData,
                time: ''
            })  
        }
    }

    const appointDataInit = () => {
        return new Promise(async resolve => {
            // let cameforom
            localStorage.setItem('came_from_page', EncryptedText('edit-appointment-delivery'));

            let appointInform = !!localStorage.getItem('appoint_inform') ? DecryptedOBJ(localStorage.getItem('appoint_inform')) : null;

            if(appointInform !== null)
            {
                let data = {
                    full_name: `${appointInform[0]["value"]} ${appointInform[1]["value"]}`, 
                    contact_number: appointInform[3]["value"],
                    email: appointInform[4]["value"]
                } 
                resolve(data);
            }else
            {
                resolve();
            }
        })
    }

    // handle set date of appointment (receive service)
    const handleSetDateAppointment = (e) => {
        let formatDate = moment(e, "DD/MM/YYYY").format("DD/MM/YYYY");
        setDorc(e)
        setAppointData({
            ...appointData,
            dorc: formatDate
        })
        // console.log('Appointment Date: ', formatDate);
    }

    // handle checkbox
    const handleCheckbox = (e) => {
        const type = e.target.name;
        const checked = e.target.checked;

        setReceiveServiceAt(type);
    } 

    // onBack
    const onBack = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/appointLists`;
    }

    const onChooseLocation = (e) => {
        let clat = e.latLng.lat();
        let clng = e.latLng.lng();
        // console.log('latitude: ', clat);
        // console.log('longtitude: ', clng);


        // set
        setLat(clat);
        setLong(clng);
        appointData["latitude"] = clat;
        appointData["longtitude"] = clng;
        window.localStorage.setItem('location', EncryptedText(`${clat}, ${clng}`));

        setGetLocationStatus(false)
        setGetLocationSuccess(true)
        document.querySelector('.map-container').classList.remove('active');
    }

    const getLocation = () => {
        setGetLocationStatus(true)
        // get location
        if(navigator.geolocation)
        {
            navigator.geolocation.getCurrentPosition(showPosition);
        }else
        {
            showAlert('Geolocation ไม่ซัพพอร์ทอุปกรณ์ของท่าน.');
            // console.log('Geolocation is not supported by this browser.')
            setGeoNotSupp(true);
        }
    }

    const showPosition = (position) => {
        // set
        setLat(position.coords.latitude);
        setLong(position.coords.longitude);
        appointData["latitude"] = position.coords.latitude;
        appointData["longtitude"] = position.coords.longitude;
        window.localStorage.setItem('location', EncryptedText(`${position.coords.latitude}, ${position.coords.longitude}`));

        setGetLocationStatus(false)
        setGetLocationSuccess(true)
        document.querySelector('.map-container').classList.remove('active');
        // log
        // console.log('Latitude: ', position.coords.latitude);
        // console.log('Longtitude: ', position.coords.longitude);
    }

    // on submit
    const handleSubmit = async(e) => {
        e.preventDefault();

        await validateSubmitForm();
        let reqData = await getReqData();
        // console.log(reqData);
        handlerUpdateAppointment(reqData);
    }

    const handlerUpdateAppointment = (reqData) => {
        // console.log('Req Data: ', reqData);
        NhealthAction.UpdateAppointment(reqData)
        .then(res => {
            if(res.isSuccess === true)
            {
                // Clear
                // localStorage.removeItem('appoint_inform');
                // Redirect
                window.location.href = `${Base_API.pathWeb}/n-health/receive-delivery-success`;
            }
            // console.log(res);
        })
    }

    const getReqData = () => {
        return new Promise(async resolve => {
            let appointInform = !!localStorage.getItem('appoint_inform') ? DecryptedOBJ(localStorage.getItem('appoint_inform')) : null; 
            let address = `${appointData.houseNumber} ${appointData.village}${!!appointData.soi ? ` ${appointData.soi}` : ''}${!!appointData.street ? ` ${appointData.street}` : ''} ${appointData.district} ${appointData.amphoe} ${appointData.province} ${appointData.zipcode}`

            let reqData = {
                "hisid": hisid,
                "Firstname": appointInform[0]["value"],
                "Lastname": appointInform[1]["value"],
                "Birthday": appointInform[2]["value"],
                "Phoneno": appointInform[3]["value"],
                "Email": appointInform[4]["value"],
                "appointmentDate": "",
                "receive_service_code": `${appointData.latitude}, ${appointData.longtitude}`,
                "receive_service": address,
                "type":0, // lab = 0 | nonlab = 1
                "ref_receive_service_code": appointData.hospital_code
            }
            resolve(reqData);
        })
    }

    const validateSubmitForm = () => {
        return new Promise(async resolve => {
            let appointInform = !!localStorage.getItem('appoint_inform') ? DecryptedOBJ(localStorage.getItem('appoint_inform')) : null;
            // console.log('Appoint Data: ', appointData);
            if(appointInform !== null)
            {
                if(appointData.hospital_code !== 'default')
                {
                    if(!!appointData.latitude)
                    {
                        if(!!appointData.houseNumber)
                        {
                            if(!!appointData.province)
                            {
                                if(!!appointData.amphoe)
                                {
                                    if(!!appointData.district)
                                    {
                                        if(!!appointData.zipcode)
                                        {
                                            resolve();
                                        }else
                                        {
                                            showAlert('กรุณาระบุรหัสไปรษณีย์');
                                        }
                                    }else
                                    {
                                        showAlert('กรุณาระบุตำบล / แขวง');
                                    }
                                }else
                                {
                                    showAlert('กรุณาระบุอำเภอ / เขต');
                                }
                            }else
                            {
                                showAlert('กรุณาระบุจังหวัด');
                            }
                        }else
                        {
                            showAlert('กรุณาระบุบ้านเลขที่');
                        }
                    }else
                    {
                        showAlert('กรุณากดค้นหาตำแหน่งของท่าน');
                    }
                }else
                {
                    showAlert('กรุณาเลือกสาขาที่สะดวกเข้ารับบริการ');
                }
            }else
            {
                showAlert('กรุณาเพิ่มข้อมูลผู้ทำนัด');
            }
        })
    }

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    const handleChagneHospital = (e) => {
        let hospital_code = String(e.target.value).split('||')[0];
        let hospital_name = String(e.target.value).split('||')[1];
        
        setAppointData({
            ...appointData,
            hospital_code: hospital_code,
            hospital_name: hospital_name
        })
    }
    const handleChangeAddress = (e) => {
        let value = e.target.value;
        setAppointData({
            ...appointData,
            address: value
        })
    }
    const handleChangeNote = (e) => {
        let value = e.target.value;
        setAppointData({
            ...appointData,
            note: value
        });
    }

    const handleChange = (e) => {
        let id = e.target.id;
        let value = e.target.value;
        appointData[id] = value;
    }

    // Small Components
    const ReceiveServiceAtBranch = (
        <div className="rcsrvbrnch-wrap">
            {/* item */}
            <div className="more">
                {/* label */}
                <p className="label">หมายเหตุ</p>
                {/* branch selection */}
                <input 
                    type="text" className="input" 
                />
            </div>
            {/* item */}
            <div className="apm-date">
                {/* label */}
                <p className="label">ทำนัดเพื่อเข้ารับบริการ (วันที่สะดวกเข้ารับบริการ)</p>
                {/* branch selection */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                        label="ระบุวันเข้ารับบริการ"
                        inputFormat="dd/MM/yyyy"
                        className='input-dob'
                        minDate={appPeriod.startDate}
                        maxDate={appPeriod.endDate}
                        disabled={datePickerStatus}
                        value={dorc}
                        onChange={(e) => handleSetDateAppointment(e)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider> 
            </div>
        </div>
    )
    const ReceiveServiceAtHome = (
        <div className="rcsrvbrnch-wrap">
            {/* บ้านเลขที่ */}
            <div>
                <p className="label">บ้านเลขที่ <RedStart_Required/></p>
                <input 
                    type="text" 
                    className="input-text"
                    id="houseNumber"
                    onChange={handleChange} 
                />
            </div>
            {/* หมู่บ้าน / คอนโด */}
            <div>
                <p className="label">หมู่บ้าน / คอนโด</p>
                <input 
                    type="text" 
                    className="input-text"
                    id="village"
                    onChange={handleChange} 
                />
            </div>
            {/* ซอย */}
            <div>
                <p className="label">ซอย</p>
                <input 
                    type="text" 
                    className="input-text"
                    id="soi"
                    onChange={handleChange} 
                />
            </div>
            {/* ถนน */}
            <div>
                <p className="label">ถนน</p>
                <input 
                    type="text" 
                    className="input-text"
                    id="street"
                    onChange={handleChange} 
                />
            </div>

            {/* province */}
            <div>
                <p className="label">จังหวัด / Province <RedStart_Required/></p>
                <select
                    onChange={(e) => onSelectedPV(e.target.value, false)}
                    id="appm3-ddad-pv"
                    className="input-text"
                >
                    {/* default */}
                    <option value="default">ระบุที่อยู่ / Address</option>
                    {/* map */}
                    {province.map((item, i) => 
                        <option 
                            key={i} 
                            value={item}
                            selected={appointData["province"] === item ? true : false}
                        >
                            {item}
                        </option>     
                    )} 
                </select>
            </div>
            {/* amphoe */}
            <div>
                <p className="label">อำเภอ / เขต District / Area <RedStart_Required/></p>
                <select
                    onChange={(e) => onSelectedAmph(e.target.value, false)}
                    id="appm3-ddad-amph"
                    className="input-text"
                >
                    {/* default */}
                    <option value="default">ระบุอำเภอ / เขต</option>
                    {/* map */}
                    {amphoe.map((item, i) => 
                        <option 
                            key={i} 
                            value={item}
                            selected={appointData["amphoe"] === item ? true : false}
                        >
                            {item}
                        </option>     
                    )} 
                </select>
            </div>
            {/* district */}
            <div>
                <p className='label'>ตำบล / แขวง Sub-district / Sub-area <RedStart_Required/></p>
                <select
                    onChange={(e) => onSelectedDist(e.target.value, false)}
                    id="appm3-ddad-dist"
                    className="input-text"
                >
                    {/* default */}
                    <option value="default">ระบุตำบล / แขวง</option>
                    {/* map */}
                    {district.map((item, i) => 
                        <option 
                            key={i} 
                            value={item}
                            selected={appointData["district"] === item ? true : false}
                        >
                            {item}
                        </option>     
                    )} 
                </select>
            </div>
            {/* zipcode */}
            <div>
                <p className="label"
                >
                    รหัสไปรษณีย์ / Postal Code <RedStart_Required/>
                </p>
                <select
                    id="appm3-ddad-zc"
                    onChange={e => onSelectedZipCode(e.target.value)}
                    className="input-text"
                >
                    {/* default */}
                    <option value="default">ระบุรหัสไปรษณีย์</option> 
                    {/* map */}
                    {zipcode.length > 0 && zipcode.map((item, i) => 
                        <option 
                            key={i} 
                            value={item}
                            selected={Number(appointData["zipcode"]) === item ? true : false}
                        >
                            {item}
                        </option>     
                    )} 
                </select>
            </div>

            {/* item */}
            <div className="more">
                {/* label */}
                <p className="label">หมายเหตุ</p>
                {/* branch selection */}
                <input type="text" className="input" />
            </div>
            {/* item */}
            {/* <div className="apm-date">
                <p className="label">ทำนัดเพื่อเข้ารับบริการ (วันที่สะดวกเข้ารับบริการ) <RedStart_Required/></p>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                        label="ระบุวันเข้ารับบริการ"
                        inputFormat="dd/MM/yyyy"
                        className='input-dob'
                        minDate={appPeriod.startDate}
                        maxDate={appPeriod.endDate}
                        datePickerStatus={datePickerStatus}
                        value={dorc}
                        onChange={(e) => handleSetDateAppointment(e)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider> 
            </div> */}
        </div>
    )

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="editapm-container">
                {/* Title */}
                <h1 className="header">ทำนัดหมาย</h1>
    
                {/* Card */}
                <form onSubmit={handleSubmit} className="card">
                    {/* header wrap */}
                    <div className="header-wrap">
                        <span className="label">ข้อมูลผู้ทำนัด</span>
                        <a href={`${Base_API.pathWeb}/n-health/edit-user-appointment/${hisid}/${campaignID}`} className="edit-usrapp">แก้ไขข้อมูล</a>
                    </div>
                    {/* card user appoint */}
                    <div className="card-userappoint">
                        <div className="item">
                            <span className="label">ชื่อผู้สั่งซื้อ</span>
                            <span className="value">{!!appointData.full_name ? appointData.full_name : '-'}</span>
                        </div>
                        <div className="item">
                            <span className="label">เบอร์ติดต่อ</span>
                            <span className="value">{!!appointData.contact_number ? appointData.contact_number : '-'}</span>
                        </div>
                        <div className="item">
                            <span className="label">อีเมล</span>
                            <span className="value">{!!appointData.email ? appointData.email : '-'}</span>
                        </div>
                    </div>

                    {/* Service Selection */}
                    <div className="sv-selection-wrap">
                        {/* label */}
                        <p className="label">สาขาที่สะดวกเข้ารับบริการ</p>
                        {/* branch selection */}
                        <select 
                            className="input"
                            onChange={handleChagneHospital}
                        >
                            {/* <option value='default||default||false'>เลือกสาขาที่รับบริการ</option> */}
                            {hospitalList !== null &&
                                hospitalList.map((item, i) => 
                                    <option
                                        key={i}
                                        value={`${item.hospital_code}||${item.hospital_name}||${item.isshowHome}`}
                                    >
                                        {item.hospital_name}
                                    </option>  
                                ) 
                            }
                        </select>
                    </div>

                    {appointData.hospital_name !== "" && appointData.hospital_name !== "default" &&
                        <div>
                            {/* Service Selection
                            <div className="service-selection">
                                <div className="item">
                                    <input 
                                        onChange={handleCheckbox}
                                        type="checkbox" 
                                        id="svslct-branch" 
                                        name="branch"
                                        checked={receiveServiceAt === 'branch' ? true : false}
                                        />
                                    <label htmlFor="svslct-branch" className="text">รับบริการที่สาขา</label>
                                </div>
                                {canSelectHome === true && isShowHome === true &&
                                    <div className="item">
                                        <input 
                                            onChange={handleCheckbox}
                                            type="checkbox" 
                                            id="svslct-home" 
                                            name="home"
                                            checked={receiveServiceAt === 'home' ? true : false}
                                            />
                                        <label htmlFor="svslct-home" className="text">รับบริการที่บ้าน</label>
                                    </div>
                                }
                            </div> */}

                            {/* Google Map Get Current Location */}
                            <div 
                                className="map-wrapp"
                                id="map-wrapp"
                                onClick={getLocationSuccess ? null : getLocation}
                            >
                                {isLoaded
                                    ? 
                                    <GoogleMap
                                        mapContainerClassName="map-container active"
                                        id='map-container'
                                        center={{lat: lat, lng: long}}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                        options={{
                                            disableDefaultUI: true, 
                                            // disableDoubleClickZoom: true, 
                                            minZoom:16, 
                                            maxZoom:25
                                        }}
                                        onClick={onChooseLocation}
                                    >
                                        { /* Child components, such as markers, info windows, etc. */ }
                                        <MarkerF position={{lat: lat, lng: long}}></MarkerF>
                                    </GoogleMap>
                                    : 
                                    null
                                }
                                <button 
                                    type="button" 
                                    id="getlocation-btn"
                                    onClick={getLocation}
                                    style={getLocationSuccess ? {display: 'none'} : {display: 'block'}}
                                >
                                    {getLocationStatus === null && 
                                        'ค้นหาตำแหน่งของท่าน'
                                    }
                                    {getLocationStatus &&
                                        <div className="map-loader"></div>
                                    }
                                </button>
                            </div>

                            {ReceiveServiceAtHome}

                            {/* Time Picker */}
                            {/* <ul className="appm-3-checkbox_item-wrapper timepicker-service">
                                {timeList.map((item, i) => 
                                    <div key={i}>
                                        <input 
                                            type="checkbox"
                                            name={item}
                                            id={item}
                                            className={`appm-3-checkbox_item`}
                                            onChange={(e) => handleCheckboxTime(e, i)}
                                        >
                                        </input>
                                        <label 
                                            className={checkboxSelected === i ? `timepckeritem appm-3-checkbox_label active` : `timepckeritem appm-3-checkbox_label`}
                                            htmlFor={item}
                                        >
                                                {String(item).length > 1 ? `${item}` : `0${item}`}
                                        </label>
                                    </div>
                                )}
                            </ul> */}
                        </div>
                    }
    
                    {/* button */}
                    <div className={appointData.hospital_name !== "" && appointData.hospital_name !== "default" ? "appm-2-button_wrapper" : "appm-2-button_wrapper float"}>
                        <button 
                            type="button"
                            className="appm-2-btn_back"
                            onClick={onBack}
                        >
                            ย้อนกลับ
                        </button>
                        <button 
                            className="appm-2-btn_submit"
                            type="submit"
                        >
                            บันทึก
                        </button>
                    </div>
                </form>
                {/* Copyright */}
                <Copyright position={'fixed'} bgColor={'#F9FBFF'} />
            </div>
        )
    }
}

export default Edit_Appointment_Delivery